import { api_type } from "../services/axios";
import { getModuleLabel } from "./constants";

export const PERMISSION_MODULES_API = "/modules";

export const getModulesApiPath = () => `/${api_type}${PERMISSION_MODULES_API}`;

export const extractModuleList = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data?.modules)) return data.modules;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data)) return data;
  return [];
};

export const normalizePermissionModule = (item = {}, index = 0) => {
  const name = item.name || item.key || "";

  return {
    id: item.id ?? item.moduleId ?? index + 1,
    name,
    label: getModuleLabel(name),
  };
};
